import React from "react";
import QRCode from "react-qr-code";

/**
 * A UPI Payment QR code — encodes a `upi://pay?...` intent URL so any UPI app
 * (Google Pay, PhonePe, Paytm, BHIM, WhatsApp Pay, Amazon Pay…) can scan it and
 * pre-fill the payee VPA, name, amount and reference automatically.
 *
 * Props:
 *   vpa        — company's UPI ID (e.g. "vetrich@okicici"). Required.
 *   payeeName  — payee display name (company legal name).
 *   amount     — invoice balance due in ₹ (rounded to 2 decimals).
 *   reference  — merchant transaction note / invoice number.
 *   size       — QR pixel size (default 108).
 *   caption    — text below the QR (default "Scan to pay").
 */
export default function UpiPayQR({ vpa, payeeName, amount, reference, size = 108, caption = "Scan to pay" }) {
  if (!vpa || amount == null || Number(amount) <= 0) return null;

  const params = new URLSearchParams({
    pa: String(vpa).trim(),
    pn: String(payeeName || "").trim().slice(0, 50) || "Vetrich",
    am: Number(amount).toFixed(2),
    cu: "INR",
    tn: String(reference || "").replace(/[^A-Za-z0-9\-_/ ]/g, "").slice(0, 40),
  });
  const upiUrl = `upi://pay?${params.toString()}`;

  return (
    <div className="flex flex-col items-center">
      <div className="bg-white p-1.5 border-2 border-emerald-600 rounded-md">
        <QRCode
          value={upiUrl}
          size={size}
          bgColor="#FFFFFF"
          fgColor="#0A0D14"
          level="M"
          style={{ height: `${size}px`, width: `${size}px`, display: "block" }}
        />
      </div>
      <div
        className="text-[9px] uppercase tracking-[0.16em] text-emerald-700 font-bold mt-1"
        style={{ fontFamily: "'Chivo', sans-serif" }}
      >
        {caption}
      </div>
      <div className="text-[9px] text-gray-500 mt-0.5 font-mono">
        ₹{Number(amount).toFixed(2)} · {vpa}
      </div>
    </div>
  );
}
